import React from 'react';

interface CrazyIFrameProps {
  src: string;
  height: number;
  title: string;
}

const CrazyIFrame: React.FC<CrazyIFrameProps> = ({ src, height, title }) => {
  return (
    <iframe
      className="a-frame loading-bg"
      src={src}
      style={{ height: height }}
      allow="gamepad *"
      title={title}
    ></iframe>
  );
};

export default CrazyIFrame;